module.exports = __webpack_public_path__ + "assets/img/15.cf91ceaf.png";